export const confirmCreditLimitEvent = {
  event: {
    category: 'application',
    action: 'application-navigation',
    location: 'credit-limit-details',
    label: 'Confirm credit limit',
  },
};
